import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import bannerImage from "../../../../assets/user/images/banner-card.png";
import { useTranslation } from "react-i18next";
import {
  TrimText,
  formateDateWithMonth,
  getSessionKey,
  removeSessionKey,
  setSessionKey,
} from "../../../../utils/commonfunction";
import CustomPagination from "../../../admin/common/custompagination";
import { RoomList, updateBooking, RoomDetails, BookingDetail, InviteesDetails } from "../../services/staffroom.services";
import Swal from "sweetalert2";
import { SWAL_SETTINGS } from "../../../../utils/Constants";
import moment from "moment";
import FrontLoader from "../../../globalComponents/FrontLoader";

const StaffRooms = () => {
  const navigate = useNavigate();
  const params = useParams();
  const { t } = useTranslation();
  const calendarModelTrigger = useRef(null);

  const [rooms, setRooms] = useState([]);
  const [itemperpage] = useState(6);
  const [page, setPage] = useState(1);
  const [datalength, setDataLength] = useState("");
  const [globalsearch, setGlobalSearch] = useState("");
  const [search, setSearch] = useState({});
  const [loader, setLoader] = useState(true);
  const [calendarBookings, setCalendarBookings] = useState([]);
  const [calenderDate, setCalenderDate] = useState(moment().format("YYYY-MM-DD"));
  const [view, setView] = useState("day"); 
  const timeSlots = Array.from({ length: 24 }, (_, i) => i);
  const startOfWeek = moment(calenderDate).startOf("week");
  const weekDays = Array.from({ length: 7 }).map((_, i) =>
    startOfWeek.clone().add(i, "day")
  );

  const startOfMonth = moment(calenderDate).startOf("month");
  const daysInMonth = startOfMonth.daysInMonth();
  const [dragData, setDragData] = useState(null);

  useEffect(() => {
    document.addEventListener("updateActivityHeight", (e) => {
      let id = e.detail.id;
      let height = e.detail.height;
      let index = e.detail.index;
      if (!getSessionKey(id) || getSessionKey(id) !== height) {
        setSessionKey(id, height);
        let element = document.getElementById("showMoreContainerbutton" + index);
        if (element) {
          removeSessionKey(id);
          if (height > 100) {
            element.classList.remove("d-none");
          }
        }
      }
    });
    return () => {
      for (let i = 0; i <= 20; i++) {
        removeSessionKey("showMoreContainer" + i);
      }
    };
  }, []);

  useEffect(() => {
    setLoader(true);
    const formData = new FormData();
    formData.append("page", params.pgno);
    formData.append("per_page", itemperpage);
    formData.append("global_search", globalsearch);
    formData.append("search", JSON.stringify(search));
    RoomList(formData)
      .then((response) => {
        if (response?.success) {
          setRooms(response?.data?.list || []);
          setDataLength(response?.data?.total_records || 0);
          setPage(response?.data?.page || 1);
          if (response?.data?.bookings_list) {
            setCalendarBookings(response.data.bookings_list);
          }
          setLoader(false);
        } else {
          Swal.fire({
            icon: "error",
            text: response.message,
            ...SWAL_SETTINGS,
            timer: 4000,
          });
          setLoader(false);
        }
      })
      .catch((err) => {
        console.log(err);
        setLoader(false);
      });
  }, [itemperpage, params.pgno, globalsearch, search, dragData]);


  const getRoomDetails = async(roomId) => {
    try{
      const response = await RoomDetails(roomId);
      if(response.success){
        return response.data;
      }
      return null;
    }catch(err){
        console.log(err);
        return null
    };
  };

  const handleShowMore = (e, id) => {
    if (e.target.classList.contains("active")) {
      e.target.classList.remove("active");
      document.getElementById(id).classList.add("max-100");
      e.target.innerText = "Show More";
    } else {
      e.target.classList.add("active");
      document.getElementById(id).classList.remove("max-100");
      e.target.innerText = "Show Less";
    }
  };

  const resetFilter = (e) => {
    e.preventDefault();
    setGlobalSearch("");
    setSearch({});
  };

  const handleClick = () => {
    calendarModelTrigger.current.click();
  };

  const goToPreviousDay = () => {
    const newDate = moment(calenderDate).subtract(1, 'day').format("YYYY-MM-DD");
    setCalenderDate(newDate);
  };

  const goToNextDay = () => {
    const newDate = moment(calenderDate).add(1, 'day').format("YYYY-MM-DD");
    setCalenderDate(newDate);
  };

  const goToToday = () => {
    setCalenderDate(moment().format("YYYY-MM-DD"));
  };

  const getBookingDetail = async(bookingId) => {
    try{
      const response = await BookingDetail(bookingId);      
      if(response.success){                
        return response.data;
      }
      return null;
    }catch(err){
        console.log(err);
        return null
    };
  };
  const getInviteesDetails = async (invitees) =>  {
    try {
      const formData = new FormData();
      formData.append('invitees', JSON.stringify(invitees));
      const response = await InviteesDetails(formData)
      return response && response.data ? response.data : [];
    } catch (error) {
      console.log("error=====>", error);
    }
  };

  // const getBookingsForRoomAndTime = (roomId, hour) => {
  //   const slotStart = moment(`${calenderDate} ${hour.toString().padStart(2, '0')}:00:00`);
  //   const slotEnd = moment(`${calenderDate} ${hour.toString().padStart(2, '0')}:59:59`);

  //   return calendarBookings.filter(booking => {
  //     const bookingStart = moment(booking.start_date);
  //     const bookingEnd = moment(booking.end_date);

  //     return booking.room_id === roomId &&
  //       bookingStart.isBefore(slotEnd) &&
  //       bookingEnd.isAfter(slotStart);
  //   });
  // };

  // const handleBookingClick = (booking, room) => {
  //   Swal.fire({
  //     title: 'Booking Details',
  //     html: `
  //       <div style="text-align: left;">
  //         <p><strong>Title:</strong> ${booking.title || 'N/A'}</p>
  //         <p><strong>Room:</strong> ${room?.name || 'N/A'}</p>
  //         <p><strong>Start:</strong> ${moment(booking.start_date).format('DD/MM/YYYY h:mm A')}</p>
  //         <p><strong>End:</strong> ${moment(booking.end_date).format('DD/MM/YYYY h:mm A')}</p>
  //       </div>
  //     `,
  //     ...SWAL_SETTINGS
  //   });
  // };

  const handleBookingClick = async(booking, room) => {
    let bookingDetail = await getBookingDetail(booking?._id);
    let inviteesData = await getInviteesDetails(bookingDetail?.invitees);
    console.log(inviteesData);
    
    const inviteesHtml = inviteesData?.length
    ? inviteesData.map(invitee => `
        <div style="margin-bottom:8px;">
          <div style="font-weight:500;"><strong>${invitee.name || '-'}</strong></div>
          <div style="font-size:15px; color:#666;"><strong>${invitee.email || ''}</strong></div>
        </div>
      `).join('')
    : '<div style="color:#888;">No invitees</div>';
    
    Swal.fire({
      title: '<h2 style="font-weight:500; margin-bottom:15px;">Booking Details</h2>',
      html: `
      <div style="
        text-align:left;
        background:#f9f9f9;
        padding:15px 20px;
        border-radius:12px;
        box-shadow:0 2px 6px rgba(0,0,0,0.1);
        font-size:15px;
        line-height:1.6;
      ">
        <p><strong>Title:</strong> ${booking.title || '-'}</p>
        <p><strong>Room:</strong> ${room?.name || '-'}</p>
        <p><strong>Start:</strong> ${moment(booking.start_date).format('DD/MM/YYYY h:mm A')}</p>
        <p><strong>End:</strong> ${moment(booking.end_date).format('DD/MM/YYYY h:mm A')}</p>

        <p style="margin-top:10px;"><strong>Invitees:</strong></p>
        <div style="padding-left:4px;">
          ${inviteesHtml}
        </div>
      </div>
    `,
      showConfirmButton: false,
      showCloseButton: true,
      width: 380,
      customClass: {
        popup: 'swal2-card-view'
      },
    });
  };


  // const calculateBookingHeight = (booking, hour) => {
  //   const slotStart = moment(`${calenderDate} ${hour.toString().padStart(2, '0')}:00:00`);
  //   const slotEnd = moment(`${calenderDate} ${(hour + 1).toString().padStart(2, '0')}:00:00`);
  //   const bookingStart = moment(booking.start_date);
  //   const bookingEnd = moment(booking.end_date);

  //   const effectiveStart = bookingStart.isAfter(slotStart) ? bookingStart : slotStart;
  //   const effectiveEnd = bookingEnd.isBefore(slotEnd) ? bookingEnd : slotEnd;

  //   const durationInMinutes = effectiveEnd.diff(effectiveStart, 'minutes');
  //   const heightPercentage = (durationInMinutes / 60) * 100;

  //   return heightPercentage;
  // };

  // const calculateBookingTop = (booking, hour) => {
  //   const slotStart = moment(`${calenderDate} ${hour.toString().padStart(2, '0')}:00:00`);
  //   const bookingStart = moment(booking.start_date);

  //   if (bookingStart.isAfter(slotStart)) {
  //     const minutesFromStart = bookingStart.diff(slotStart, 'minutes');
  //     return (minutesFromStart / 60) * 100;
  //   }
  //   return 0;
  // };

  const getBookingsForRoomAndTime = (roomId, hour) => {
  const slotStart = moment(`${calenderDate} ${hour.toString().padStart(2, '0')}:00:00`);
  const slotEnd = moment(`${calenderDate} ${hour.toString().padStart(2, '0')}:59:59`);

  return calendarBookings.filter(booking => {
    const bookingStart = moment(booking.start_date);
    const bookingEnd = moment(booking.end_date);

    return booking.room_id === roomId &&
      bookingStart.format('YYYY-MM-DD') === calenderDate &&
      bookingStart.hour() === hour;
  });
};

const calculateBookingHeight = (booking) => {
  const bookingStart = moment(booking.start_date);
  const bookingEnd = moment(booking.end_date);
  const durationInMinutes = bookingEnd.diff(bookingStart, 'minutes');
  const heightInPixels = (durationInMinutes / 60) * 60;
  return heightInPixels;
};

const calculateBookingTop = (booking, hour) => {
  const slotStart = moment(`${calenderDate} ${hour.toString().padStart(2, '0')}:00:00`);
  const bookingStart = moment(booking.start_date);
  const minutesFromStart = bookingStart.diff(slotStart, 'minutes');
  return minutesFromStart;
};

  const handleDragStart = (e, booking, room) => {
    console.log( booking, room);
    
    setDragData({ booking, room });
  };

  const handleDrop = (e, newRoom, newHour,dropDay = null) => {
    if (!dragData) return;

      const { booking } = dragData;

      const duration = moment(booking.end_date)
        .diff(moment(booking.start_date), "minutes");
        
      const baseDate = dropDay ? moment(dropDay) : moment(calenderDate);

      const newStart = baseDate
        .clone()
        .hour(newHour)
        .minute(0);

      const newEnd = newStart.clone().add(duration, "minutes");
    
      const payload = {
        _id: booking._id,
        event_id: newRoom.event_id?._id ?? newRoom.event_id,
        room_id: newRoom._id,
        title: booking.title,
        start_date: newStart.toISOString(),
        end_date: newEnd.toISOString(),
      };
      
    // API call here
    updateBooking(payload)
      .then((response) => {
        if (response?.success) {
          Swal.fire({
            icon: "success",
            text: response?.message,
            ...SWAL_SETTINGS,
          });
        }else {
          Swal.fire({
            icon: "error",
            text: response?.message,
            ...SWAL_SETTINGS,
          });
        }
        
      });

    setDragData(null);
  };


  const renderBookingBlock = (booking, room = null) => {
    return (
      <div
        key={booking._id}
        draggable
        onDragStart={(e) => handleDragStart(e, booking, room)}
        onClick={() => handleBookingClick(booking, room)}
        style={{
          background: '#3788d8',
          color: 'white',
          padding: '4px',
          borderRadius: '4px',
          cursor: 'move',
          fontSize: '12px',
          marginBottom: '2px'
        }}
      >
        <div style={{ fontWeight: 'bold' }}>
          {booking.title || 'Booking'}
        </div>
        <div style={{ fontSize: '11px' }}>
          {moment(booking.start_date).format('HH:mm')} - {moment(booking.end_date).format('HH:mm')}
        </div>
      </div>
    );
  };

  return (
    <>
      <div className="wraper-inner cpt bg-grey">
        <section className="banner-card mt-4">
          <div className="container">
            <div
              className="banner-card-content text-center"
              style={{ backgroundImage: `url(${bannerImage})` }}
            >
              <h1>{t("Rooms")}</h1>
              <nav className="breadcrumb text-center">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to={`/`}>{t("web_header_heading_home")}</Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    {t("Rooms")}
                  </li>
                </ol>
              </nav>
            </div>
          </div>
        </section>

        <section className="forums-listing grid-box-main mt-5 pb-5">
          <div className="container">
            <div className="user-box-head d-flex justify-content-between mb-4">
              <h3 className="inner-title mb-0"></h3>
              <div className="user-right filter-responsive d-flex align-items-center">
                <div className="search-box ms-1">
                  <input
                    type="text"
                    className="form-control rounded-3"
                    placeholder={t("web_lbl_search")}
                    value={globalsearch}
                    onChange={(e) => setGlobalSearch(e.target.value)}
                  />
                  <button className="btn-search">
                    <i className="ti ti-search"></i>
                  </button>
                </div>

                <button className="btn btn-warning ms-1" onClick={resetFilter}>
                  {t("web_lbl_reset_filter")}
                </button>
                <button
                  className="btn btn-success ms-1"
                  onClick={() => handleClick()}
                >
                  Calendar View
                </button>
              </div>
            </div>

            <div className="row mt-2">
              {loader ? (
                <FrontLoader />
              ) : rooms && rooms.length > 0 ? (
                rooms.map((data, i) => (
                  <div className="col-md-4" key={i}>
                    <div className="grid_back h-100">
                      <div className="grid-box d-flex flex-column justify-content-between align-items-start">
                        <div className="w-100">
                          <h3 className="text-capitalize">
                            {data?.name ? TrimText(data?.name) : null}
                          </h3>
                          <div className="d-flex justify-content-center mb-4">
                            <div
                              className="d-flex justify-content-center align-items-center w-100"
                              style={{
                                backgroundColor: "var(--light_active_color)",
                              }}
                            >
                              <i
                                className="ri-home-7-line"
                                style={{
                                  fontSize: "8em",
                                  color: "var(--primary_active_color)",
                                }}
                              ></i>
                            </div>
                          </div>
                          <div className="date-info">
                            <i className="ri-calendar-event-line"></i>
                            {formateDateWithMonth(data?.start_date)} -{" "}
                            {formateDateWithMonth(data?.end_date)}
                          </div>
                          <div
                            className="surveyPage max-100"
                            id={"showMoreContainer" + i}
                            ref={(el) => {
                              if (el) {
                                const evt = new CustomEvent("updateActivityHeight", {
                                  detail: {
                                    id: "showMoreContainer" + i,
                                    index: i,
                                    height: el.scrollHeight,
                                  },
                                });
                                document.dispatchEvent(evt);
                              }
                            }}
                            dangerouslySetInnerHTML={{
                              __html: data?.description,
                            }}
                          ></div>

                          <div
                            className="d-flex justify-content-end w-100 d-none mt-2"
                            id={"showMoreContainerbutton" + i}
                          >
                            <button
                              type="button"
                              className="show-more"
                              onClick={(e) =>
                                handleShowMore(e, "showMoreContainer" + i)
                              }
                            >
                              Show More
                            </button>
                          </div>
                        </div>
                        <button
                          className="btn btn-primary mt-2"
                          onClick={() =>
                            navigate(`/rooms/book/${data?._id}`, {
                              state: { event_id: data?.event_id },
                            })
                          }
                        >
                          {t("web_sis_user_book")}
                        </button>
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <h2 style={{ textAlign: "center", fontSize: "25px" }}>
                  {t("web_lbl_no_records")}
                </h2>
              )}
            </div>

            {datalength > 0 && (
              <div className="mt-4 text-right pagination-main d-flex justify-content-end pe-4">
                <CustomPagination
                  datalength={datalength}
                  itemperpage={itemperpage}
                  currentPage={page}
                  setPage={setPage}
                  pageRoute={[{ name: "Rooms", path: "/rooms/list" }]}
                />
              </div>
            )}
          </div>
        </section>
      </div>

      <a
        className="d-none"
        ref={calendarModelTrigger}
        data-bs-toggle="modal"
        href="#CalendarModal"
        role="button"
      >
        <span></span>
      </a>

      <div
        className="modal fade"
        id="CalendarModal"
        aria-hidden="true"
        data-bs-backdrop="static"
        aria-labelledby="CalendarModalLabel"
        tabIndex={-1}
      >
        <div className="modal-dialog modal-fullscreen">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="CalendarModalLabel">
                Room Bookings Calendar
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                id="close_calendar_modal"
              ></button>
            </div>

            <div className="modal-body p-0">
              <div className="container-fluid">
                {rooms.length === 0 ? (
                  <div className="text-center py-5">
                    <h4>No Rooms Available</h4>
                    <p className="text-muted">Please add rooms to view calendar</p>
                  </div>
                ) : (
                  <div>
                    {/* Calendar Header */}
                    <div className="d-flex justify-content-between align-items-center p-3 border-bottom">
                      <h4 className="mb-0">{moment(calenderDate).format('MMMM D, YYYY')}</h4>
                      <div className="d-flex gap-2 align-items-center">
                        <input
                          type="date"
                          className="form-control"
                          style={{ width: '160px' }}
                          value={calenderDate}
                          onChange={(e) => setCalenderDate(e.target.value)}
                        />
                        <button className="btn btn-secondary" onClick={goToToday}>
                          Today
                        </button>
                        <button className="btn btn-primary" onClick={goToPreviousDay}>
                          &lt;
                        </button>
                        <button className="btn btn-primary" onClick={goToNextDay}>
                          &gt;
                        </button>
                      </div>
                        <div className="btn-group ms-2">
                          <button
                            className={` ${view === "day" ? "btn btn-secondary" : "btn btn-primary"}`}
                            onClick={() => setView("day")}
                          >
                            Day
                          </button>
                          <button
                            className={` ${view === "week" ? "btn btn-secondary" : "btn btn-primary"}`}
                            onClick={() => setView("week")}
                          >
                            Week
                          </button>
                          <button
                            className={` ${view === "month" ? "btn btn-secondary" : "btn btn-primary"}`}
                            onClick={() => setView("month")}
                          >
                            Month
                          </button>
                        </div>
                    </div>

                    {/* Calendar Grid */}
                    {view === "day" && (
                      <div style={{ overflowX: 'auto', overflowY: 'auto', maxHeight: '70vh' }}>
                        <table className="table table-bordered" style={{ minWidth: '800px' }}>
                          <thead style={{ position: 'sticky', top: 0, background: 'white', zIndex: 10 }}>
                            <tr>
                              <th style={{ width: '80px', minWidth: '80px' }}>Time</th>
                              {rooms.map((room) => (
                                <th key={room._id} style={{ minWidth: '200px', textAlign: 'center' }}>
                                  {room.name}
                                </th>
                              ))}
                            </tr>
                          </thead>
                          <tbody>
                            {timeSlots.map((hour) => (
                              <tr key={hour} style={{ height: '60px' }}>
                                <td style={{
                                  verticalAlign: 'top',
                                  padding: '4px 8px',
                                  fontWeight: '500',
                                  background: '#f8f9fa'
                                }}>
                                  {hour.toString().padStart(2, '0')}:00
                                </td>
                                {rooms.map((room) => {
                                  const bookings = getBookingsForRoomAndTime(room._id, hour);
                                  return (
                                    <td
                                      key={`${room._id}-${hour}`}
                                      onDragOver={(e) => e.preventDefault()}
                                      onDrop={(e) => handleDrop(e, room, hour)}
                                      style={{
                                        position: 'relative',
                                        padding: 0,
                                        verticalAlign: 'top',
                                        background: hour % 2 === 0 ? '#fafafa' : 'white'
                                      }}
                                    >
                                      {bookings.map((booking, idx) => {
                                        const bookingStart = moment(booking.start_date);
                                        const slotStart = moment(`${calenderDate} ${hour.toString().padStart(2, '0')}:00:00`);

                                        // Only render if this is the starting slot
                                        if (bookingStart.hour() !== hour) {
                                          return null;
                                        }

                                        const height = calculateBookingHeight(booking, hour);
                                        const top = calculateBookingTop(booking, hour);

                                        return (
                                          <div
                                            key={idx}
                                              draggable
                                              onDragStart={(e) =>
                                                handleDragStart(e, booking, room)
                                              }
                                              onClick={() => handleBookingClick(booking, room)}
                                              style={{
                                                top: `${top}%`,
                                                left: '2px',
                                                right: '2px',
                                                height: `${height}%`,
                                                background: '#3788d8',
                                                color: 'white',
                                                padding: '4px',
                                                borderRadius: '4px',
                                                cursor: 'move',
                                                overflow: 'hidden',
                                                fontSize: '12px',
                                                zIndex: 1
                                              }}
                                          >
                                            <div style={{ fontWeight: 'bold' }}>
                                              {booking.title || 'Booking'}
                                            </div>
                                            <div style={{ fontSize: '11px' }}>
                                              {moment(booking.start_date).format('HH:mm')} - {moment(booking.end_date).format('HH:mm')}
                                            </div>
                                          </div>
                                        );
                                      })}
                                    </td>
                                  );
                                })}
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    )}
                    {view === "week" && (
                      <div style={{ overflowX: "auto", maxHeight: "70vh" }}>
                        <table className="table table-bordered">
                          <thead>
                            <tr>
                              <th style={{ width: "80px" }}>Time</th>
                              {weekDays.map((day) => (
                                <th key={day.format()} className="text-center">
                                  {day.format("ddd DD")}
                                </th>
                              ))}
                            </tr>
                          </thead>
                          <tbody>
                            {timeSlots.map((hour) => (
                              <tr key={hour}>
                                <td>{hour.toString().padStart(2, "0")}:00</td>

                                {weekDays.map((day) => (
                                  <td
                                    key={day.format() + hour}
                                    style={{ height: "60px", position: "relative" }}
                                    onDragOver={(e) => e.preventDefault()}
                                    onDrop={async(e) => {
                                      if (!dragData) return;

                                      const { booking } = dragData;
                                      const roomDetails = await getRoomDetails(booking.room_id);
                                      
                                      handleDrop(e, roomDetails, hour,day);

                                      setDragData(null);
                                    }}

                                  >
                                    {calendarBookings
                                      .filter((booking) =>
                                        moment(booking.start_date).format("YYYY-MM-DD") ===
                                          day.format("YYYY-MM-DD") &&
                                        moment(booking.start_date).hour() === hour
                                      )
                                      .map((booking) =>
                                        renderBookingBlock(booking)
                                      )}
                                  </td>
                                ))}
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    )}

                    {view === "month" && (
                      <div className="p-3">
                        <div className="row">
                          {Array.from({ length: daysInMonth }).map((_, i) => {
                            const day = startOfMonth.clone().add(i, "day");

                            return (
                              <div
                                key={i}
                                className="col-2 border p-2"
                                style={{ minHeight: "120px" }}
                                onDragOver={(e) => e.preventDefault()}
                                onDrop={async(e) => {
                                  if (!dragData) return;

                                  const { booking } = dragData;

                                  const roomDetails = await getRoomDetails(booking.room_id);
                                  
                                  handleDrop(e, roomDetails, 9,day);

                                  setDragData(null);
                                }}

                              >
                                <div style={{ fontWeight: "bold" }}>
                                  {day.format("DD")}
                                </div>

                                {calendarBookings
                                  .filter(
                                    (booking) =>
                                      moment(booking.start_date).format("YYYY-MM-DD") ===
                                      day.format("YYYY-MM-DD")
                                  )
                                  .map((booking) =>
                                    renderBookingBlock(booking)
                                  )}
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default StaffRooms;